import { Command, HttpMethod } from "~/extensions/api";
export class ImpersonationCommand extends Command {
    constructor(nyukyokeiyakuNo, userCd, lifeKainNo) {
        super(HttpMethod.Post, "auth/impersonation");
        this.nyukyokeiyakuNo = nyukyokeiyakuNo;
        this.userCd = userCd;
        this.lifeKainNo = lifeKainNo;
    }
    nyukyokeiyakuNo;
    userCd;
    lifeKainNo;
}
